// Events are prefixed automatically by the AiTeammateAnalyticsProvider
export const AI_TEAMMATE_EVENTS = {
  DRAWER_OPENED: "Drawer Opened",
  DRAWER_CLOSED: "Drawer Closed",
  NEW_THREAD_CREATED: "New Thread Created",
  THREAD_RESET: "Thread Reset",
  MESSAGE_SENT: "Message Sent",
  // { theme: string, prompt_id: string, surface: "empty_state" | "collapsed" }
  SUGGESTED_PROMPT_SHOWN: "Suggested Prompt Shown",
  // { theme: string, prompt_id: string }
  SUGGESTED_PROMPT_CLICKED: "Suggested Prompt Clicked",
  // { source: "suggested_prompt" | "nudge" | "typed", promptId?: string, theme?: string }
  CHAT_MESSAGE_SENT: "Chat Message Sent",
  // { theme: string }
  CATEGORY_EXPANDED: "Category Expanded",
  PROMPTING_GUIDE_OPENED: "Prompting Guide Opened",
  // Discoverability nudge anchored to the chat button (once per session)
  NUDGE_SHOWN: "Nudge Shown",
  // { reason: "dismissed" | "opened_chat" | "question_clicked" }
  NUDGE_DISMISSED: "Nudge Dismissed",
  // { prompt_id: string }
  NUDGE_QUESTION_CLICKED: "Nudge Question Clicked",
  PLOT_EXPANDED: "Plot Expanded",
  TABLE_EXPANDED: "Table Expanded",
  TABLE_EXPLAIN_OPENED: "Table Explain Opened",
  ARTIFACT_PIN_INITIATED: "Artifact Pin Initiated",
  ARTIFACT_PIN_SUCCESS: "Artifact Pin Success",
  ARTIFACT_PIN_FAILED: "Artifact Pin Failed",
} as const

export type AiTeammateEventName = typeof AI_TEAMMATE_EVENTS[keyof typeof AI_TEAMMATE_EVENTS]
